



















































































































































































































import { Component, Vue } from 'vue-property-decorator';
import scrollService from '@/core/scroll/scroll.service';

import DonatePayPal from '@/components/frontpage/user/Donate/DonatePayPal.vue';

import Tabs from '@/core/layout/Tabs/Tabs.vue';
import Tab from '@/core/layout/Tabs/Tab.vue';
import { UserModule } from '@/store/modules/user/user.store';

@Component({
    components: { Tabs, Tab, DonatePayPal }
})
export default class Donate extends Vue {
    loading: boolean = false;

    get accepted() {
	    return UserModule.user?.hasAcceptedDonationTerms;
    }

    get user() {
	    return UserModule.user;
    }

    async accept() {
        this.loading = true;

        try {
            await UserModule.acceptDonationTerms();

	    setTimeout(() => {
	        scrollService.scrollToElement(this.$refs.header, -200);
	    }, 500);
        } finally {
            this.loading = false;
        }
    }

	public $refs!: {
		header: HTMLElement;
    };
}
